import React from 'react'

const FormDashboardLabel = ({children}) => {
  return (
    <label className="mb-2 block w-full font-bold text-sm">{children}</label>
  )
}

export { FormDashboardLabel }